import { mapActions, mapGetters } from 'vuex';
import { buildCordlessIspAddressFromGeo, getProviderKey, renderImpressionTrackers, selectIspProviders } from '@/dpp/utilities/cordless-isp.js';

const ISP_EXPERIMENT = 'movoto-dpp-isp-CW-4648';

export default {
    name: 'propertySummaryDetails',
    inject: ['$eventBus', 'split'],
    data() {
        return {
            ispProviders: [],
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getMortgagePerMonth', 'getEstimatePriceRange', 'getEstimateInfo', 'getEstRentFee']),
        hideEstMonthCost() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule && compliance[0].rule.indexOf('hideEstMonthCost') >= 0;
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        ...mapActions('glb', ['fetchCordlessIspProviders']),
        getProviderKey,
        openDisclaimer() {
            if (this.getEstimateInfo && this.getEstimateInfo.type === 'avm') {
                this.$eventBus.$emit('dialog-center', { name: 'dppPopAvm', opt: {}, trigger: this.$options.name });
            } else {
                this.$eventBus.$emit('dialog-center', { name: 'dppPopEst', opt: {}, trigger: this.$options.name });
            }
        },
        perHOAUnit() {
            const compliance = this.getComplianceMethod()();
            if (compliance[0]) {
                if ((compliance[0].rule.indexOf('hideHOAUnitLand') >= 0 && this.dpp.propertyType === 'LAND') || compliance[0].rule.indexOf('hideHOAUnit') >= 0) {
                    return '';
                }
            }
            return '/month';
        },
        async initialISP() {
            const treatment = await this.split.fetchTreatments([ISP_EXPERIMENT], {
                attributes: {
                    movoto_geo_zipcode: this.dpp?.geo?.zipcode,
                    movoto_geo_state: this.dpp?.geo?.state,
                    movoto_listing_price: this.dpp?.price,
                    movoto_listing_type: this.dpp?.propertyType,
                    movoto_listing_status: this.dpp?.houseRealStatus,
                },
            });
            if (treatment[ISP_EXPERIMENT] !== 'on') {
                return;
            }
            const addressPayload = buildCordlessIspAddressFromGeo(this.dpp && this.dpp.geo);
            if (!addressPayload) {
                return;
            }

            try {
                const response = await this.fetchCordlessIspProviders(addressPayload);
                const rawProviders = response && response.providers;
                const providers = selectIspProviders(rawProviders);
                this.ispProviders = providers;
                this.$eventBus.$emit('ga', {
                    en: 'dpp_isp_call',
                    ec: 'ISP',
                    el: providers?.length?.toString() || 'null',
                });
                this.$nextTick(() => {
                    renderImpressionTrackers(this.$refs.ispTrackers, rawProviders);
                });
            } catch (err) {
                this.ispProviders = [];
            }
        },
        onIspClick(provider) {
            this.$eventBus.$emit('ga', {
                en: 'ad_click',
                ec: 'ISP',
                el: 'Cordless',
                props: { link_name: (provider && provider.name) || '' },
            });
        },
    },
    mounted() {
        this.initialISP();
    },
};
